import { FC, useMemo } from 'react';
import cx from 'classnames';
import { RiskKeys } from '@/config';
import { useTranslation } from 'react-i18next';
import { AmlHistoryItemData } from '@/redux/models';
import { SvgIcon } from '@/components';

import styles from './SanctionNote.module.sass';

interface SanctionNoteProps {
  item: AmlHistoryItemData;
  isLoading?: boolean;
  isPromo?: boolean;
}

const SanctionNote: FC<SanctionNoteProps> = (props) => {
  const { item, isPromo, isLoading } = props;
  const { t } = useTranslation();

  const sanctioned = useMemo(() => {
    if (item.signalTags && item.signalTags.length > 0) {
      return item.signalTags.includes(RiskKeys.SANCTIONS);
    }
    return item.signals && item.signals[RiskKeys.SANCTIONS];
  }, [item.signals, item.signalTags]);

  const sanctionNote = useMemo(() => {
    if (sanctioned) {
      return t('translation.sanction_block_danger');
    }
    return t('translation.sanction_block_trusted');
  }, [t, sanctioned]);

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={cx(
        styles.box,
        styles[`box--${sanctioned ? 'danger' : 'trusted'}`],
      )}
    >
      <div className={styles.title}>
        {t('translation.sanction_block_title')}
      </div>
      <div className={styles.note}>
        <SvgIcon
          name={`shield-${sanctioned ? 'red' : 'green'}`}
          className={styles.icon}
        />{' '}
        {sanctionNote}
      </div>
    </div>
  );
};

export default SanctionNote;
